<script setup lang="ts">
import {computed} from "vue";

interface Props {
    size?: 'sm' | 'md' | 'lg'
}

const props = withDefaults(defineProps<Props>(), {
    size: 'md',
})

const cols = computed(() => {
    switch (props.size) {
    case 'sm':
        return 4
    case 'md':
        return 5
    case 'lg':
        return 7
    default:
        return 5
    }
})
</script>

<template>
    <v-app class="system-font">
        <v-main>
            <v-container :fluid="true">
                <v-row
                    class="mt-0"
                    align="center"
                    justify="center"
                >
                    <v-col
                        cols="8"
                        :sm="cols"
                        :md="cols - 1"
                        :lg="cols - 2"
                        :xl="cols - 3"
                    >
                        <slot />
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<style scoped>

</style>
